import { Button, Form } from "react-bootstrap";
import CustomModal from "../../components/customModal/CustomModal";
import { handleNumberInput } from "../../utils/commonUtils";

interface OtpVerificationModalProps {
  otpValue: string;
  otpError: string | null;
  verifyOTPLoading?: boolean;
  onOtpChange: (value: string) => void;
  onSubmit: () => void;
  onClose: () => void;
}

const OtpVerificationModal: React.FC<OtpVerificationModalProps> = ({
  otpValue,
  otpError,
  verifyOTPLoading,
  onOtpChange,
  onSubmit,
  onClose,
}) => {
  return (
    <CustomModal
      id="otp-verification-modal"
      title="Two-Factor Authentication"
      content={
        <div>
          <p style={{ marginBottom: "1rem" }}>
            Please enter the OTP sent to your registered email or
            phone.
          </p>
          <Form.Group className="mb-3">
            <Form.Label>Enter OTP</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter OTP"
              value={otpValue}
              onChange={(e) => onOtpChange(e.target.value)}
              onInput={handleNumberInput}
              isInvalid={!!otpError}
            />
            {otpError && (
              <Form.Control.Feedback type="invalid">
                {otpError}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <Button
              variant="primary"
              onClick={onSubmit}
              disabled={verifyOTPLoading}
              className="flex-grow-1"
            >
              Verify OTP
            </Button>
            <Button
              variant="secondary"
              onClick={onClose}
              className="flex-grow-1"
            >
              Cancel
            </Button>
          </div>
        </div>
      }
      onClose={onClose}
    />
  );
};

export default OtpVerificationModal;
